module.exports = __webpack_public_path__ + "static/media/Employees-selected-icon.5e6d327c.svg";